import React, { Component } from "react";
import { withCars } from "./../../../shared/containers/containerCars";
import { withFilterCars } from "./../../../shared/containers/containerFilterCars";
import Preloader from "./../../../shared/items/static/preloader";
import Notification from "./../../../shared/items/static/notification";
import CarsListReportsItems from "./../reports/carsListReportsItems";

import { states } from "./../../../reducers/queriesStates";

import styles from "./carsListReports.module.scss";
import { withSignalR } from "../../../shared/containers/containerSignalR";
import { withAuth } from "../../../shared/containers/containerAuth";
import { unitFilterService } from "../cars/unitFilterService";

class CarsListReports extends Component {
  componentDidMount() {
    unitFilterService.didMount(this.props);
  }

  componentWillUnmount() {
    const { onStopConnect, connectionSR } = this.props;

    if (!!connectionSR) onStopConnect(connectionSR);

    unitFilterService.clearTimeoutConnection();
  }

  componentDidUpdate(prevProps) {
    unitFilterService.didUpdate(prevProps, this.props);
  }

  render() {
    const { handleScrollTo, dataStateUnits, listUnits } = this.props;

    return (
      <React.Fragment>
        <div className={styles.reportsCarsList_wrapper}>
          {listUnits.length > 0 ? (
            <div className={styles.carsList}>
              <CarsListReportsItems data={listUnits} handleScrollTo={handleScrollTo} />
            </div>
          ) : (
            <Notification type="warning">
              <p>По данным параметрам поиска автомобили не найдены.</p>
            </Notification>
          )}

          {dataStateUnits !== states.READY ? (
            <div className={styles.container_preloader}>
              <Preloader />
            </div>
          ) : null}
        </div>
      </React.Fragment>
    );
  }
}

export default withAuth(withSignalR(withCars(withFilterCars(CarsListReports))));
